import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EMBEDDED_CUSTOMER_STATUSES } from 'pages/EmbeddedCustomers/helpers/constants'
import { DashboardCardState } from 'pages/EmbeddedCustomers/helpers/types'

export const useDashboardCards = (initialActiveCard?: string) => {
  const [activeCard, setActiveCard] = useState<string | null>(initialActiveCard || null)

  const handleCardClick = useCallback((step: string) => {
    setActiveCard(prevStep => (prevStep === step ? null : step))
  }, [])

  const { t } = useTranslation()

  const dashboardCards = useMemo<DashboardCardState[]>(
    () => [
      {
        step: '1',
        title: t('embeddedCustomers.dashboard.agreements'),
        status: EMBEDDED_CUSTOMER_STATUSES.PENDING_AGREEMENTS,
        queue: '0',
        type: 'neutral',
      },
      {
        step: '2',
        title: t('embeddedCustomers.dashboard.dataCollection'),
        status: EMBEDDED_CUSTOMER_STATUSES.INFO_REQUIRED,
        queue: '0',
        type: 'neutral',
      },
      {
        step: '3',
        title: t('embeddedCustomers.dashboard.decisionApproval'),
        status: EMBEDDED_CUSTOMER_STATUSES.PENDING,
        queue: '0',
        type: 'neutral',
      },
      {
        step: '4',
        title: t('embeddedCustomers.dashboard.walletCreation'),
        status: EMBEDDED_CUSTOMER_STATUSES.VERIFIED,
        queue: '0',
        type: 'neutral',
      },
      {
        step: '5',
        title: t('embeddedCustomers.dashboard.onboarded'),
        status: EMBEDDED_CUSTOMER_STATUSES.VERIFIED,
        queue: '0',
        type: 'success',
      },
    ],
    []
  )

  return {
    activeCard,
    handleCardClick,
    dashboardCards,
  }
}
